import http from '../../http/common'

const resource = '/staff'

export default {

	create: (payload) => http.post(resource, payload),

	get: (payload, params) => http.post(`${resource}/get-data${params}`, payload),

	getList: (payload, params) => http.post(`${resource}/get-list${params}`, payload),

	show: (id, params) => http.get(`${resource}/${id}${params}`),

	update: (id, payload) => http.put(`${resource}/${id}`, payload),

	delete: (id) => http.delete(`${resource}/${id}`),

	search: (params) => http.get(`${resource}/search${params}`),

	archive: (id, payload) => http.post(`${resource}/${id}/update-status`, payload),

	upload: (payload) => http.post(`${resource}/upload-docs`, payload),

	playerid: (payload) => http.post(`${resource}/update-playerid`, payload),

}
